var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6924 7.80791C15.6924 3.5597 12.2485 0.115601 8.00005 0.115601C3.75184 0.115601 0.307739 3.5597 0.307739 7.80791C0.307739 9.62483 0.939534 11.2941 1.99287 12.6102L1.99312 12.6112L1.9921 12.6118C3.97825 15.0923 6.78518 18.5982 7.69953 19.74C7.77261 19.831 7.88312 19.8841 7.99979 19.8843C8.11671 19.8843 8.22748 19.8315 8.3003 19.7402C9.21415 18.5987 12.0203 15.0943 14.0065 12.6135L14.0067 12.6125L14.0057 12.612C15.06 11.2953 15.6924 9.62611 15.6924 7.80791ZM12.7608 11.7077L8.00005 17.6541L3.28543 11.7659L3.23723 11.7059C3.22312 11.6866 3.20877 11.6677 3.19389 11.6489C2.3121 10.5471 1.8462 9.21893 1.8462 7.80791C1.8462 4.41457 4.60697 1.65406 8.00005 1.65406C11.3931 1.65406 14.1539 4.41457 14.1539 7.80791C14.1539 9.2197 13.6875 10.5484 12.8047 11.6505C12.7898 11.6692 12.7752 11.6882 12.7608 11.7077Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 10.5002C9.48694 10.5002 10.6923 9.29485 10.6923 7.80793C10.6923 6.32101 9.48694 5.11562 8.00002 5.11562C6.5131 5.11562 5.30771 6.32101 5.30771 7.80793C5.30771 9.29485 6.5131 10.5002 8.00002 10.5002Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.1bc112b481608541b43bde0e40fb0dc2.svg";
export { ForwardRef as ReactComponent };